import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NotificationType } from '../../shared/models/notification-type';
import { DialogService } from '../../shared/services/dialog/dialog.service';
import { NotificationService } from '../../shared/services/notification/notification.service';
import { UtilityService } from '../../shared/services/utility/utility.service';
import { INotifyTemplate } from '../models/notify-template.interface';
import {
  NotifyTemplatePreviewDialogComponent,
} from '../notify-template-preview-dialog/notify-template-preview-dialog.component';
import { NotifyTemplateService } from '../services/notify-template.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'upsc-notify-template',
    templateUrl: './notify-template.component.html',
    styleUrls: ['./notify-template.component.scss'],
})
export class NotifyTemplateComponent implements OnInit, OnChanges {
    @Input() template: INotifyTemplate;
    @Output() templateRemoved: EventEmitter<INotifyTemplate> = new EventEmitter<INotifyTemplate>();

    public isEmptyTemplate = false;

    constructor(private notificationService: NotificationService,
                private dialogService: DialogService,
                private utilityService: UtilityService,
                private dialog: MatDialog,
                private notifyTemplateService: NotifyTemplateService,
                private translateService: TranslateService,
    ) {
    }

    public ngOnInit() {
        if (!this.template) {
            this.template = {
                TemplateId: '',
                TemplateName: '',
                PPITemplateName: '',
                CoverBannerS3Url: '',
                BannerS3Url: '',
                shouldDisplayShowcaseImages: true,
                ShowCaseImg1S3Url: 'https://members.parcelpro.com',
                ShowCaseImg2S3Url: 'https://members.parcelpro.com',
                ShowCaseImg3S3Url: 'https://members.parcelpro.com',
                CreatedOn: '',
                CustomerWebsite: '',
                IsPrimary: false,
                isInProgress: false,
            };

            this.isEmptyTemplate = true;
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.onTemplateChanged(changes.template);
    }

    public showPreview(event) {
        event.preventDefault();

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            data: {
                template: this.template,
            },
        };

        const dialogRef = this.dialog.open(NotifyTemplatePreviewDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(
            (result) => {
                if (!result) {
                    return;
                }
            },
        );
    }

    public confirmTemplateRemoval(event) {
        event.preventDefault();

        if (this.template.IsPrimary) {
            const title = this.translateService.instant('notifyTemplates.removePrimaryTemplateTitle');
            const message = this.translateService.instant('notifyTemplates.removePrimaryTemplateMessage');
            this.dialogService.alert(title,message);

            return;
        }
        const title = this.translateService.instant('notifyTemplates.removeTemplateTitle');
        const message = this.translateService.instant('notifyTemplates.removeTemplateMessage');
        this.dialogService.confirm(title, message)
            .subscribe(
                (isConfirmed) => {
                    if (!isConfirmed) {
                        return;
                    }

                    this.removeTemplate();
                },
            );
    }

    private removeTemplate() {
        this.template.isInProgress = true;

        this.notifyTemplateService.deleteNotifyTemplate(this.template.TemplateId)
            .subscribe(
                (result) => {
                    this.utilityService.delay(() => {
                        this.template.isInProgress = false;
                    });

                    if (!result) {
                        this.notificationService.notify(
                            'The system failed to remove the template. Please try again later.',
                            'Failed removing template',
                            NotificationType.ERROR);
                    } else {
                        this.templateRemoved.emit(this.template);
                    }
                },
            );
    }

    private onTemplateChanged(change: SimpleChange): void {
        if (!change?.currentValue) {
            return;
        }
    }

    public removePlusSignFromTemplateName(templateName: string): string {
        return templateName.replace(/\+/g, " ");
    } 
}
